"use strict";

(function(){

let self = Fotobook.dialog = {

    /**
     * Обертка для jQyery.dialog
     *
     * @param {string} content HTML content
     * @param {object} options
     * @returns {undefined}
     */
    open(content, options){

        options = $.extend({
            "title" : "",
            "autoOpen": true,
            "modal": true,
            "resizable": false,
            "draggable": true,
            "width": "auto",
            "noClose" : false,
            "dialogClass" : "",
            "fotobookDialogClass" : "",
            "buttons" : [],
            "close": function(){
                try {
                    $(this).html("").dialog("destroy").remove();
                } catch (exception){
                }
            },
        }, options || {});
        options.dialogClass = options.dialogClass.addClass("fotobook-dialog").addClass(options.fotobookDialogClass);
        if (options.noClose){
            options.dialogClass = options.dialogClass.addClass("no-close");
        }
        return $(content).dialog(options);
    },

    /**
     *
     * Закрытие диалога.
     *
     * Прим.:
     * var dialog = Fotobook.dialog.alert(...);
     * ....
     * Fotobook.dialog.close(dialog);
     *
     * @param {type} $dialog
     * @returns {undefined}
     */
    close($dialog){
        if ($dialog instanceof HTMLElement){
            $dialog = $($dialog);
        }
        if ($dialog instanceof jQuery){
            try {
                $dialog.dialog("close");
            } catch (error){
            }
        }
    },

    _autoClose: function(event){
        const $e = $(this);
        setTimeout(() => {
            if (!$e || !$e.length){
                return;
            }
            try {
                let autoClose = $e.dialog("option", "autoClose");
                if (typeof autoClose === "boolean" && autoClose){
                    $e.dialog("close");
                }
            } catch (exception){}
        }, 0);
    },



    _do_not_ask_tpl : [
        '<input type="checkbox" id="{unique-id}" data-id="{doNotAskKey}" class="do-not-ask-again" value="" tabindex="-1">',
        '<label for="{unique-id}" class="styled-label uniform-sprite-image-ba before" tabindex="-1">', t("photobook-js-do-not-ask-again"), '</label>',
    ].join(""),
    insertDoNotAsk($dialog, doNotAskKey){
        $dialog.closest(".ui-dialog").find(".ui-dialog-buttonpane").prepend(this._do_not_ask_tpl.supplant({
            "unique-id": Fotobook.book.getUniqueId(),
            "doNotAskKey" : doNotAskKey,
        }));
        $dialog.then(() => {
            if ($dialog.closest(".ui-dialog").find(".do-not-ask-again").prop("checked")) {
                self.doNotAsk.set(doNotAskKey);
            }
        }).catch(() => {});
    },

    /**
     * Диалог подтверждения.
     * Служит для показа диалогов, логика которых состоит в ответе на вопрос с ответом да/нет/отмена
     *
     * Опции:
     *   buttonResolve        : string - текст для кнопки подтверждения (выполняет resolve)
     *   buttonReject         : string - текст для кнопки отказа (выполняет reject);
     *   buttonCancel         : string - текст для кнопки отмены диалога (ничего не делает, закрывает диалог);
     *   showButtonResolve    : boolean - показывать ли кнопку подтверждения
     *   showButtonReject     : boolean - показывать ли кнопку отказа
     *   showButtonCancel     : boolean - показывать ли кнопку отмены диалога
     *   disableButtonResolve : boolean - показывать ли кнопку подтверждения отключённой
     *   disableButtonReject  : boolean - показывать ли кнопку отказа отключённой
     *   disableButtonCancel  : boolean - показывать ли кнопку отмены диалога отключённой
     *   resolved             : boolean|function - условие, по которому диалог не показывается, сразу считается подтверждённым
     *   rejected             : boolean|function - условие, по которому диалог не показывается, сразу считается отказанным
     *   doNotAskKey          : string - ключ для хранения состояния "больше не спрашивать"
     *
     * @param {string} text
     * @param {object} options
     * @returns jQuery object + promise
     */
    _confirm_buttons: [
        {
            "show" : "showButtonResolve",
            "disable" : "disableButtonResolve",
            "text" : "buttonResolve",
            "classes": "fotobook-dialogbutton-resolve fotobook_button functional-button",
        },
        {
            "show" : "showButtonReject",
            "disable" : "disableButtonReject",
            "text" : "buttonReject",
            "classes": "fotobook-dialogbutton-reject fotobook_button neutral-button",
        },
        {
            "show" : "showButtonCancel",
            "disable" : "disableButtonCancel",
            "text" : "buttonCancel",
            "classes": "fotobook-dialogbutton-cancel fotobook_button neutral-button",
        },
    ],

    /**
     * Реализация опции resolveOnEnter у диалога confirm и alert
     *
     * Ловит нажатие enter на input внутри диалога (исключая некоторые типы), после
     * чего кликает на resolve-кнопку диалога
     *
     * Следует обратить внимание: у формы внутри диалога не доолжно быть инпутов типа submit
     * иначе форма будет отправлена самостоятельно. Также (!!!) форма будет отправлена самостоятельно,
     * если в ней только одно доступное пользователю поле. В таком случае простейший способ обхода
     * проблемы - добавить невидимое поле типа текст, без name.
     *
     * Из-за невозможности отличить отправку формы кликом по сабмиту от нажатия enter в поле input,
     * такие ситуации пока что не обрабатываем. Следует либо отключать эту опцию, либо обеспечивать
     * отсутствие input[type=submit] в формах внтури диалога
     */
    resolveOnEnter(event){
        let $target = $(event.target),
            $dialog = $target.closest(":ui-dialog"),
            widget = $dialog.data("ui-dialog"),
            type = $target.attr("type");

        if (!widget || !widget.options || !widget.options.resolveOnEnter){
            return;
        }
        if (event.keyCode !== $.ui.keyCode.ENTER){
            return;
        }
        if ($target.is("input") && ["image", "button", "submit", "reset", "checkbox", "file", "hidden", "radio"].indexOf(type) !== -1){
            return;
        }
        setTimeout(() => {
            let $button;
            if (widget && widget.uiDialogButtonPane){
                $button = widget.uiDialogButtonPane.find(".fotobook-dialogbutton-resolve");
                if ($button.length && !$button.hasClass("disabled")){
                    $button.click();
                }
            }
        }, 0);
    },

    /**
     * @param text
     * @param options
     * @returns {jQuery|Promise}
     */
    confirm(text, options){
        let resolve,
            reject,
            promiseState = "pending",
            promise = new Promise((rv, rj) => {
                resolve = function(){
                    promiseState = "resolved";
                    return rv(...arguments);
                };
                reject = function(){
                    promiseState = "rejected";
                    return rj(...arguments);
                };
            });

        let $dialog = $(),
            buttons = [],
            closeOnEscape,
            checkResolve = (event) => {
                let data;
                if (promiseState !== "pending"){
                    return false;
                }
                if (!((typeof options.beforeResolve !== "function") || (data = options.beforeResolve.call($dialog, event)))) {
                    return false;
                }
                if (typeof data === "object" && typeof data.then === "function"){
                    data.then(() => resolve(null, data)).catch(() => {});
                } else {
                    resolve(event, data);
                }
                return true;
            },
            click = function(event){
                if (!event || !event.currentTarget){
                    return;
                }
                const $button = $(event.currentTarget);
                if ($button.hasClass("disabled")){
                    return;
                }

                if ($button.hasClass("fotobook-dialogbutton-resolve")){
                    checkResolve(event);
                } else if ($button.hasClass("fotobook-dialogbutton-reject")){
                    reject(event);
                } else if ($button.hasClass("fotobook-dialogbutton-cancel")){
                    self._autoClose.call(this, [event]);
                }

            };

        options = $.extend({
            "width": 350,
            "modal": true,
            "closeOnEscape": false,
            "fotobookDialogClass" : "fotobook-dialog-confirm",
            "autoClose": true,

            "showButtonResolve" : true,
            "disableButtonResolve" : false,
            "buttonResolve": t("photobook-js-buttonsYes"),

            "showButtonReject" : true,
            "disableButtonReject" : false,
            "buttonReject": t("photobook-js-buttonsNo"),

            "showButtonCancel" : false,
            "disableButtonCancel" : false,
            "buttonCancel": t("photobook-js-buttonsCancel"),

            "closeButtonAction" : "reject",
            "resolveOnEnter" : false,

            "resolved" : false,
            "rejected" : false,
            "zIndex": Fotobook.book.zindex.ModalDialog,
            "doNotAskKey" : false,
            "doNotAskCallback" : null,
        }, options || {});

        if (typeof options.rejected === "function"){
            options.rejected = options.rejected();
        }

        if (options.rejected){
            reject();
            return this.mergePromiseToDialog($dialog, promise);
        }

        if (typeof options.resolved === "function"){
            options.resolved = options.resolved();
        }

        if (options.resolved || options.doNotAskKey && this.doNotAsk.check(options.doNotAskKey)){
            if (options.doNotAskKey && options.doNotAskCallback){
                promise.then(options.doNotAskCallback).catch(() => {});
            }
            resolve();
            return this.mergePromiseToDialog($dialog, promise);
        }

        for (let i=0; i<self._confirm_buttons.length; i++){
            let buttonInfo = self._confirm_buttons[i];
            if (!options[buttonInfo["show"]]){
                continue;
            }
            buttons.push({
                "text": options[buttonInfo.text],
                "class": options[buttonInfo.disable] ? buttonInfo.classes.addClass("disabled") : buttonInfo.classes,
                "click": click,
            });
        }
        options.buttons = buttons;

        // при закрытии на крестик, и не только
        // !!! так делать НЕЛЬЗЯ - приводит к проблемам !!!
/*        options.close = function(){
            deferred.reject();
        };
*/
        if (options.closeOnEscape && (options.closeButtonAction === "reject" || options.closeButtonAction === "resolve")){
            closeOnEscape = true;
            options.closeOnEscape = false;
        }
        $dialog = this.mergePromiseToDialog(this.open(this._wrap_dialog_content(text, options), options), promise);

        if (options.closeButtonAction === "reject" || options.closeButtonAction === "resolve"){
            $dialog.data("ui-dialog").uiDialogTitlebarClose.off("click").on("click", function(event){
                if (options.closeButtonAction === "resolve"){
                    checkResolve(event);
                } else {
                    reject(event);
                }
            });
        }

        if (closeOnEscape){
            let widget = $dialog.data("ui-dialog");

            widget._on(widget.uiDialog, {
                "keydown": function(event) {
                    if (event.isDefaultPrevented() || !event.keyCode || event.keyCode !== $.ui.keyCode.ESCAPE) {
                        return;
                    }
                    if (options.closeButtonAction === "resolve"){
                        if (checkResolve(event)){
                            event.preventDefault();
                        }
                    } else {
                        reject(event);
                        event.preventDefault();
                    }
                },
            });
        }

        if (options.doNotAskKey){
            this.insertDoNotAsk($dialog, options.doNotAskKey);
        }

        promise.finally(() => self._autoClose.call($dialog)).catch(() => {});

        return $dialog;
    },

    /**
     * Диалог оповещения
     *
     * @param {string} text
     * @param {object} options
     * @returns jQuery object + promise
     */
    alert(text, options){
        return this.confirm(text, $.extend({
            "fotobookDialogClass" : "fotobook-dialog-alert",
            "noClose" : true,
            "buttonResolve" : t("photobook-js-buttonsOk"),
            "showButtonReject" : false,
        }, options || {}));
    },

    /**
     * Добавляет методы промиса к диалогу
     *
     * @param $dialog jQuery
     * @param promise Promise
     * @returns jQuery|Promise
     */
    mergePromiseToDialog($dialog, promise){
        $dialog.then = function(){
            return promise.then(...arguments);
        };
        $dialog.catch = function(){
            return promise.catch(...arguments);
        };
        $dialog.finally = function(){
            return promise.finally(...arguments);
        };
        return $dialog;
    },
    /**
     * Диалог выбора одной из кнопок
     *
     * @param {string} text
     * @param {object} options
     * @returns jQuery|Promise
     */
    choose(text, options){
        options = $.extend({
            "autoClose" : true,
            "modal" : true,
            "width" : 500,
            "zIndex": Fotobook.book.zindex.ModalDialog,
        }, options || {});

        const promise = new Promise((resolve/*, reject*/) => {
            const click = (event) => {
                if (!event || !event.currentTarget || $(event.currentTarget).hasClass("disabled")){
                    return;
                }
                resolve(event);
            };

            for (let i=0; i<options.buttons.length; i++){
                if (!options.buttons[i].click){
                    options.buttons[i].click = click;
                }
            }
        });

        let $dialog = this.open(this._wrap_dialog_content(text, options), options);

        promise.finally(() => self._autoClose.call($dialog));

        return this.mergePromiseToDialog($dialog, promise);
    },

    html: function(html, options){
         options = $.extend({
            "title": '',
            "fotobookDialogClass": 'fotobook-dialog-html',
        }, options || {});
        return this.open(this._wrap_dialog_content(html, options), options);
    },

    _wrap_dialog_content: function(html, options){
        options = options || {};

        return [
            '<div', (options.contentId ? ' id="'+options.contentId+'"' : ''), (options.contentClass ? ' class="'+options.contentClass+'"' : ''),'>',
                html,
            '</div>',
        ].join('');
    },
};

self.doNotAsk = {
    key: "dlg_confirm_do_not_ask",
    readData: function(){
        return (Fotobook.userSettings.get(this.key) || "").split(",").filter(function(keyPart){
            return keyPart;
        });
    },
    saveData: function(data){
        return Fotobook.userSettings.set(this.key, data.join(","));
    },

    check: function(key){
        return this.readData().indexOf(key) !== -1;
    },
    set: function(key){
        let data = this.readData();
        if (data.indexOf(key) === -1){
            data.push(key);
            this.saveData(data);
        }
    },
    reset: function(key){
        let data = this.readData(),
            idx = data.indexOf(key);
        if (idx !== -1){
            data.splice(idx, 1);
            this.saveData(data);
        }
    },
};


$(document).on("keypress", ".fotobook-dialog input,.fotobook-dialog select", self.resolveOnEnter);

})();
